import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { DEVICE_NAME, getStoredFingerprint, setStoredFingerprint } from 'auth/storage';

function createFallbackUniqueId(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return `zendesk-${Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')}`;
}

export async function resolveUniqueId(): Promise<string> {
  const existing = getStoredFingerprint();
  if (existing) {
    return existing;
  }

  try {
    const agent = await FingerprintJS.load();
    const { visitorId } = await agent.get();
    setStoredFingerprint(visitorId);
    return visitorId;
  } catch {
    const fallback = createFallbackUniqueId();
    setStoredFingerprint(fallback);
    return fallback;
  }
}

export function withDeviceFields<T extends Record<string, unknown>>(
  values: T,
  uniqueId: string
): T & { deviceName: string; uniqueId: string } {
  return {
    ...values,
    deviceName: DEVICE_NAME,
    uniqueId,
  };
}
